import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Le récapitulatif de l’offre — le seul bloc avec le prix et le vrai bouton du checkout. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-120" data-mp="2casmghtuu7yj">
      <div className="mx-auto max-w-5xl" data-id="element-121" data-mp="28ai6ccccm15y">
        <SectionHeading id="offer-heading" title={<>
              Tout ce dont vous avez besoin pour <Accent data-id="element-123" data-mp="1yjx8ws8ev2om">mieux organiser vos formations en barbering.</Accent>
            </>} data-id="element-122" data-mp="23iid12qsa6ic" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(20,40,59,0.45)]" data-id="element-124" data-mp="2vz1ix42fl03u">
          <div className="bg-brand-charcoal px-6 py-4 text-center" data-id="element-125" data-mp="3chs52xfhx3sq">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-126" data-mp="3cijvltu8kbc5">
              Barber Instructor Ready™ — Édition française
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-127" data-mp="33p80lgciw4zz">
            <img src={MOCKUP_URL} alt="Tout ce qui est inclus dans Barber Instructor Ready — Édition française" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[580px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(20, 40, 59, 0.16))'
          }} data-id="element-128" data-mp="37qjqlmzb6s8p" />

            <ul className="mx-auto mt-10 grid max-w-xl gap-x-8 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-129" data-mp="2osz42mk0o5r9">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-130" data-mp="n0ucxdacdchl">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-131" data-mp="1vy19isijhtl3" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex items-baseline justify-center gap-3 border-y border-brand-charcoal/10 py-6" data-id="element-132" data-mp="1mwb7ksr17c92">
              <span className="font-display text-[3rem] font-bold leading-none text-brand-gold" data-id="element-133" data-mp="1hz1ije7k12lr">11</span>
              <span className="font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-charcoal" data-id="element-134" data-mp="2emz8c3osmfm7">
                Ressources numériques · Accès immédiat
              </span>
            </div>

            <CtaBlock label="Obtenir mon accès immédiat" showPrice className="mt-9" data-id="element-135" data-mp="25ue0vjqm3vco" />
            <p className="mt-4 text-center font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-136" data-mp="20w2s7cc1zqw1">
              Aucun abonnement · Ressources numériques · Contenu en français
            </p>
          </div>
        </div>
      </div>
    </section>;
}